"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.group.monitoring.audit.config", {
            url: "/configuracao",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-monitoring-config" */ "../../company/monitoring-config/monitoring-config.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.monitoringConfig")
                );
            },
            params: {
                source: "financial"
            },
            views: {
                "admin@nucont.accounting": {
                    component: "monitoringConfigComponent",
                    bindings: { companyData: "groupData" }
                },
                "monitoringConfigType@nucont.accounting.group.monitoring.audit.config": {
                    component: "monitoringConfigAuditComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            resolve: {
                type: [
                    () => {
                        return "audit";
                    }
                ]
            }
        })
        .state("nucont.accounting.group.monitoring.health.config", {
            url: "/configuracao",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-monitoring-config" */ "../../company/monitoring-config/monitoring-config.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.monitoringConfig")
                );
            },
            params: {
                source: "financial"
            },
            views: {
                "admin@nucont.accounting": {
                    component: "monitoringConfigComponent",
                    bindings: { companyData: "groupData" }
                },
                "monitoringConfigType@nucont.accounting.group.monitoring.health.config": {
                    component: "monitoringConfigHealthComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            resolve: {
                type: [
                    () => {
                        return "health";
                    }
                ]
            }
        });
}
